<template>
    <div class="tone-talk" v-if="userAuthenticated && userSignature && getDemoEvent">
        <spinner class="pink" v-model="toggleSpinner" v-if="toggleSpinner" size="lg" fixed text="joining event"></spinner>
        <h2>Hey, Great to see you. <br>Enjoy the Tone Talk!</h2>
        <div class="container" v-if="!getDemoEvent.jwRtmpUrl">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-7">
                    <h3>discussion</h3>
                    <div v-if="userSignature">
                        <iframe width="100%" height="650" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" allowtransparency="true" :src="chatRollURL"></iframe>
                        <button class="btn-pink" @click="leaveEvent"><i class="fa fa-sign-out"></i>&nbsp;Leave</button>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-5">
                    <h3>moderator</h3>
                    <div class="moderatorContent" v-if="getExpert">
                        <img class="userImg" :src="getExpert[0].small_image" :alt="getExpert[0].name" :title="getExpert[0].name">
                        <h4>{{getExpert[0].name}}</h4>
                        <h5>{{getExpert[0].expertise}}</h5>
                        <p>
                            {{getDemoEvent.longDescription}}
                        </p>
                        <!--<h3 v-if="eventUsersArray">attendees</h3>-->
                        <!--<div class="slider responsive-slick-eventusers" v-if="eventUsersArray">-->
                            <!--<div class="attendeesImg" v-for="userList in eventUsersArray">-->
                                <!--<div class="userImage" v-if="userList[0]">-->
                                    <!--<div v-if="userList[0].isAnonymous === '0'">-->
                                        <!--<img :src="userList[0].picture" alt="">-->
                                        <!--<span>{{userList[0].firstName}}</span>-->
                                    <!--</div>-->
                                    <!--<div v-else>-->
                                        <!--<img :src="userList[0].picture" alt="">-->
                                        <!--<span>Shoe-cognito</span>-->
                                        <!--&lt;!&ndash;<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<span>Anonymous</span>&ndash;&gt;-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--<div class="userImage" v-if="userList[1]">-->
                                    <!--<div class="userImage" v-if="userList[1]">-->
                                        <!--<div v-if="userList[1].isAnonymous === '0'">-->
                                            <!--<img :src="userList[1].picture" alt="">-->
                                            <!--<span>{{userList[1].firstName}}</span>-->
                                        <!--</div>-->
                                        <!--<div v-else>-->
                                            <!--<img :src="userList[1].picture" alt="">-->
                                            <!--<span>Shoe-cognito</span>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--<div class="userImage" v-if="userList[2]">-->
                                    <!--<div class="userImage" v-if="userList[2]">-->
                                        <!--<div v-if="userList[2].isAnonymous === '0'">-->
                                            <!--<img :src="userList[2].picture" alt="">-->
                                            <!--<span>{{userList[2].firstName}}</span>-->
                                        <!--</div>-->
                                        <!--<div v-else>-->
                                            <!--<img :src="userList[2].picture" alt="">-->
                                            <!--<span>Shoe-cognito</span>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--<div class="userImage" v-if="userList[3]">-->
                                    <!--<div class="userImage" v-if="userList[3]">-->
                                        <!--<div v-if="userList[3].isAnonymous === '0'">-->
                                            <!--<img :src="userList[3].picture" alt="">-->
                                            <!--<span>{{userList[3].firstName}}</span>-->
                                        <!--</div>-->
                                        <!--<div v-else>-->
                                            <!--<img :src="userList[3].picture" alt="">-->
                                            <!--<span>Shoe-cognito</span>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--<div class="userImage" v-if="userList[4]">-->
                                    <!--<div class="userImage" v-if="userList[4]">-->
                                        <!--<div v-if="userList[4].isAnonymous === '0'">-->
                                            <!--<img :src="userList[4].picture" alt="">-->
                                            <!--<span>{{userList[4].firstName}}</span>-->
                                        <!--</div>-->
                                        <!--<div v-else>-->
                                            <!--<img :src="userList[4].picture" alt="">-->
                                            <!--<span>Shoe-cognito</span>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--<div class="userImage" v-if="userList[5]">-->
                                    <!--<div class="userImage" v-if="userList[5]">-->
                                        <!--<div v-if="userList[5].isAnonymous === '0'">-->
                                            <!--<img :src="userList[5].picture" alt="">-->
                                            <!--<span>{{userList[5].firstName}}</span>-->
                                        <!--</div>-->
                                        <!--<div v-else>-->
                                            <!--<img :src="userList[5].picture" alt="">-->
                                            <!--<span>Shoe-cognito</span>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--<div class="userImage" v-if="userList[6]">-->
                                    <!--<div class="userImage" v-if="userList[6]">-->
                                        <!--<div v-if="userList[6].isAnonymous === '0'">-->
                                            <!--<img :src="userList[6].picture" alt="">-->
                                            <!--<span>{{userList[6].firstName}}</span>-->
                                        <!--</div>-->
                                        <!--<div v-else>-->
                                            <!--<img :src="userList[6].picture" alt="">-->
                                            <!--<span>Shoe-cognito</span>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--<div class="userImage" v-if="userList[7]">-->
                                    <!--<div class="userImage" v-if="userList[7]">-->
                                        <!--<div v-if="userList[7].isAnonymous === '0'">-->
                                            <!--<img :src="userList[7].picture" alt="">-->
                                            <!--<span>{{userList[7].firstName}}</span>-->
                                        <!--</div>-->
                                        <!--<div v-else>-->
                                            <!--<img :src="userList[7].picture" alt="">-->
                                            <!--<span>Shoe-cognito</span>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--<div class="userImage" v-if="userList[8]">-->
                                    <!--<div class="userImage" v-if="userList[8]">-->
                                        <!--<div v-if="userList[8].isAnonymous === '0'">-->
                                            <!--<img :src="userList[8].picture" alt="">-->
                                            <!--<span>{{userList[8].firstName}}</span>-->
                                        <!--</div>-->
                                        <!--<div v-else>-->
                                            <!--<img :src="userList[8].picture" alt="">-->
                                            <!--<span>Shoe-cognito</span>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-else>
            <div class="rowtight">
                <div class="col-sm-8 innerpadding">
                    <div  class="embed-responsive embed-responsive-16by9" v-if="getDemoEvent">
                        <iframe  class="embed-responsive-item" :src="getDemoEvent.jwRtmpUrl" frameborder="0" scrolling="auto" allowfullscreen ></iframe>
                    </div>
                </div>
                <div class="col-sm-4 text-left">
                    <div v-if="userSignature">
                        <h4>TONE Topic: {{getDemoEvent.title}}</h4>
                        <p>{{getDemoEvent.jwStreamTitle}}</p>
                        <h6>Total Participants: 1</h6>
                        <iframe width="100%" height="280px" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" allowtransparency="true" :src="chatRollURL"></iframe>
                        <button class="btn-pink" @click="leaveEvent"><i class="fa fa-sign-out"></i>&nbsp;Leave</button>
                        <!--<iframe width="100%" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" allowtransparency="true" src="https://chatroll.com/embed/chat/adam-test-11012017?id=QAVZFiECp2J&platform=html&uid=330&uname=Abdul&sig=8c0e653bb27d4157a387b3b71b1b90e7&ismod=0&upic=https://s3.amazonaws.com/tone-assets/images/profile-pictures-new/small/shoes_ked.jpg"></iframe>-->
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-xs-12 col-sm-12 col-md-7">

                    <!--<div class="talkContent">-->
                    <!--<div class="userContent">-->
                    <!--&lt;!&ndash;////////////////////////&ndash;&gt;-->
                    <!--<div class="user">-->
                    <!--<div class="image">-->
                    <!--<img src="../assets/user-one.png" alt="">-->
                    <!--</div>-->
                    <!--<div class="name">-->
                    <!--<h6>Stacy <span>4:38 PM</span></h6>-->
                    <!--<p>Lorem ipsum dolor sit emit.</p>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;////////////////////////&ndash;&gt;-->
                    <!--<div class="user">-->
                    <!--<div class="image">-->
                    <!--<img src="../assets/user-two.png" alt="">-->
                    <!--</div>-->
                    <!--<div class="name">-->
                    <!--<h6>helen <span>4:38 PM</span></h6>-->
                    <!--<p>-->
                    <!--Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris-->
                    <!--nisi ut aliquip ex ea commodo consequat.-->
                    <!--</p>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;////////////////////////&ndash;&gt;-->
                    <!--<div class="user">-->
                    <!--<div class="image">-->
                    <!--<img src="../assets/user-three.png" alt="">-->
                    <!--</div>-->
                    <!--<div class="name">-->
                    <!--<h6>jane <span>4:38 PM</span></h6>-->
                    <!--<p>-->
                    <!--Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris-->
                    <!--nisi ut aliquip ex ea commodo consequat.-->
                    <!--</p>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;////////////////////////&ndash;&gt;-->
                    <!--</div>-->
                    <!--<div class="questionContent">-->
                    <!--<img class="commentIcon" src="../assets/live-question.png" alt="">-->
                    <!--<h3>How do I stay on track with ipsum dolor sit amet, consectetur edipiscing?</h3>-->
                    <!--<img class="arrow" src="../assets/live-event-down-errow.png" alt="">-->
                    <!--</div>-->
                    <!--<div class="talkButton">-->
                    <!--<button type="button">Submit your question</button>-->
                    <!--</div>-->
                    <!--</div>-->
                </div>
                <!--Start Commenting Code for new Inteface-->
                <!--<div class="col-xs-12 col-sm-12 col-md-5">-->
                <!--<h3>moderator</h3>-->
                <!--<div class="moderatorContent" v-if="getExpert">-->
                <!--<img class="userImg" :src="getExpert[0].small_image" alt="">-->
                <!--<h4>{{getExpert[0].name}}</h4>-->
                <!--<h5>{{getExpert[0].expertise}}</h5>-->
                <!--<p>-->
                <!--{{getSelectedEvent[0].longDescription}}-->
                <!--</p>-->
                <!--<h3>attendees</h3>-->
                <!--<div class="slider responsive-slick-eventusers" v-if="eventUsersArray">-->
                <!--<div class="attendeesImg" v-for="userList in eventUsersArray">-->
                <!--<div class="userImage" v-if="userList[0]">-->
                <!--<div v-if="userList[0].isAnonymous === '0'">-->
                <!--<img :src="userList[0].picture" alt="">-->
                <!--<span>{{userList[0].firstName}}</span>-->
                <!--</div>-->
                <!--<div v-else>-->
                <!--<img :src="userList[0].picture" alt="">-->
                <!--<span>Shoe-cognito</span>-->
                <!--&lt;!&ndash;<img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/>&ndash;&gt;-->
                <!--&lt;!&ndash;<span>Anonymous</span>&ndash;&gt;-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="userImage" v-if="userList[1]">-->
                <!--<div class="userImage" v-if="userList[1]">-->
                <!--<div v-if="userList[1].isAnonymous === '0'">-->
                <!--<img :src="userList[1].picture" alt="">-->
                <!--<span>{{userList[1].firstName}}</span>-->
                <!--</div>-->
                <!--<div v-else>-->
                <!--<img :src="userList[1].picture" alt="">-->
                <!--<span>Shoe-cognito</span>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="userImage" v-if="userList[2]">-->
                <!--<div class="userImage" v-if="userList[2]">-->
                <!--<div v-if="userList[2].isAnonymous === '0'">-->
                <!--<img :src="userList[2].picture" alt="">-->
                <!--<span>{{userList[2].firstName}}</span>-->
                <!--</div>-->
                <!--<div v-else>-->
                <!--<img :src="userList[2].picture" alt="">-->
                <!--<span>Shoe-cognito</span>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="userImage" v-if="userList[3]">-->
                <!--<div class="userImage" v-if="userList[3]">-->
                <!--<div v-if="userList[3].isAnonymous === '0'">-->
                <!--<img :src="userList[3].picture" alt="">-->
                <!--<span>{{userList[3].firstName}}</span>-->
                <!--</div>-->
                <!--<div v-else>-->
                <!--<img :src="userList[3].picture" alt="">-->
                <!--<span>Shoe-cognito</span>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="userImage" v-if="userList[4]">-->
                <!--<div class="userImage" v-if="userList[4]">-->
                <!--<div v-if="userList[4].isAnonymous === '0'">-->
                <!--<img :src="userList[4].picture" alt="">-->
                <!--<span>{{userList[4].firstName}}</span>-->
                <!--</div>-->
                <!--<div v-else>-->
                <!--<img :src="userList[4].picture" alt="">-->
                <!--<span>Shoe-cognito</span>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="userImage" v-if="userList[5]">-->
                <!--<div class="userImage" v-if="userList[5]">-->
                <!--<div v-if="userList[5].isAnonymous === '0'">-->
                <!--<img :src="userList[5].picture" alt="">-->
                <!--<span>{{userList[5].firstName}}</span>-->
                <!--</div>-->
                <!--<div v-else>-->
                <!--<img :src="userList[5].picture" alt="">-->
                <!--<span>Shoe-cognito</span>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="userImage" v-if="userList[6]">-->
                <!--<div class="userImage" v-if="userList[6]">-->
                <!--<div v-if="userList[6].isAnonymous === '0'">-->
                <!--<img :src="userList[6].picture" alt="">-->
                <!--<span>{{userList[6].firstName}}</span>-->
                <!--</div>-->
                <!--<div v-else>-->
                <!--<img :src="userList[6].picture" alt="">-->
                <!--<span>Shoe-cognito</span>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="userImage" v-if="userList[7]">-->
                <!--<div class="userImage" v-if="userList[7]">-->
                <!--<div v-if="userList[7].isAnonymous === '0'">-->
                <!--<img :src="userList[7].picture" alt="">-->
                <!--<span>{{userList[7].firstName}}</span>-->
                <!--</div>-->
                <!--<div v-else>-->
                <!--<img :src="userList[7].picture" alt="">-->
                <!--<span>Shoe-cognito</span>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="userImage" v-if="userList[8]">-->
                <!--<div class="userImage" v-if="userList[8]">-->
                <!--<div v-if="userList[8].isAnonymous === '0'">-->
                <!--<img :src="userList[8].picture" alt="">-->
                <!--<span>{{userList[8].firstName}}</span>-->
                <!--</div>-->
                <!--<div v-else>-->
                <!--<img :src="userList[8].picture" alt="">-->
                <!--<span>Shoe-cognito</span>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--End Commenting Code for new Inteface-->

            </div>
        </div>
    </div>
    <div v-else>
        <div class="community-content" v-if="getDemoEvent">
            <div class="container">
                <img src="../assets/community-icon.png" alt="">
                <h2 style="text-transform:none;">Join the Conversation at <span v-if="getDemoEvent.type === '1'">TONE Live</span><span v-else>TONE Talk</span></h2>
                <div class="communityBox" v-if="getDemoEvent">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-6" v-if="getExpert">
                            <jwplayer v-if="currentVideo" :data="currentVideo">Loading the player...</jwplayer>
                            <!--<img v-bind:src="getExpert[0].small_image" alt="">-->
                            <img v-if="!currentVideo" v-bind:src="getDemoEvent.imgUrl" alt="">
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6" v-if="getExpert">
                            <h2>{{getDemoEvent.title}} with {{getExpert[0].name}}</h2>
                            <p v-if="getExpert[0]">
                                {{getDemoEvent.longDescription}}
                            </p>
                            <h5>{{getDateReference(getDemoEvent.startDate, 'str')}}
                            </h5>
                            <div title="Add to Calendar" class="addeventatc pinkoutlinebtn">
                                Add to Calendar
                                <span class="start">{{getDemoEvent.startDate}}</span>
                                <span class="timezone">America/New_York</span>
                                <span class="title">{{getDemoEvent.title}}</span>
                                <span class="description">{{getDemoEvent.longDescription}}</span>
                            </div>
                            <!--<button class="button btn btn-pink btn-primary pull-left"  v-if="showJoin(bannerEvent)" type="button" @click="joinEvent(bannerEvent)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp</button>-->
                            <!--time left in event {{timeLeftInEvent(getMainEvent.start_date)}}-->
                            <!--<button type="button" >Reserve your spot starting November 13th!</button>-->
                        </div>
                    </div>
                    <div class="col-md-12 pinkbordercomp">
                        <div>
                        <h3>Choose how you want to join the event. You can join as yourself or step into someone else's shoes using our anonymous shoe-cognito mode</h3>
                        <br><br>
                        <button type="button" @click="switchEventView()" title="Join event">Gemma</button>
                            <button type="button" @click="switchEventView()" title="Join event">Shoe-Incognito</button>
                            <div>
                                Please follow the event guidelines:
                                <span>1.)</span> Keep it positive, supportive and respectful;
                                <span>2.)</span> Please be thoughtful and stay on topic;
                                <span>3.)</span> Please do not post copyrighted material, ads, solicitations or anyone's personal info including your own;
                                <span>4.)</span> Please refer to TONE's <a href="/terms" target="new" title="click to view our terms">Terms of Service</a> for more information.
                            </div>
                        <!--<button type="button" @click="joinEvent('1')" title="Join event as shoe-cognito">Shoe-cognito</button>-->
                        </div>

                    </div>
                </div>
            </div>
            <br>
            <br>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import $ from 'jquery'
    import slick from 'slick-carousel'
    import jwplayer from './JwPlayer.vue'
    import {spinner} from 'vue-strap'
    export default {
        name: 'demoTalk',
        components: {
            jwplayer,
            spinner
        },
        metaInfo () {
            return {
                title: 'TONE | TONE Event',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Event'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | Event'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                chatRollURL: '',
                eventUsersArray: [],
                eventUserArray: [],
                chatrllRef: '',
                intervalId: '',
                jwEventRef: '',
                userSignature: 'b443b3462870037c9ac0aecf05bc5ca8',
                userAuthenticated: false,
                userType: 0,
                toggleSpinner: false,
                currentVideo: null,
                participantCount: 0,
                userRef: 0,
                seatReservation: {
                    userEventId: 0,
                    eventId: 0,
                    userId: 0,
                    status: 0,
                    isAnonymous: 0
                }
            }
        },
        watch: {
            'userAuthenticated' (to, from) {
                if (this.userAuthenticated) {
                    this.toggleSpinner = true
                    setTimeout(() => {
                        this.toggleSpinner = false
                    }, 2500)
                }
            }
        },
        methods: {
            switchEventView () {
                let self = this
                // Predefined Signature for Dev or Localhost
//                if (window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('dev-') > -1) {
//                    self.userSignature = 'b443b3462870037c9ac0aecf05bc5ca8'
//                    self.userRef = 1169
//                } else {
//                    self.userSignature = 'b443b3462870037c9ac0aecf05bc5ca8'
//                    self.userRef = 1169
//                }
                self.userSignature = self.getDemoEvent.userSignagure
                self.userRef = self.getDemoEvent.userRef
                console.log('user ref', self.userRef)
                self.chatRollURL = `${self.getDemoEvent.chatrollEventUrl}&uid=${self.userRef}&uname=Shoe-cognito&sig=${self.userSignature}&ismod=0&upic=https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg`
                console.log('chatrol ref', self.chatRollURL)
                self.userAuthenticated = true
                window.scrollTo(0, 0)
            },
            joinEvent (isAnonymous) {
                this.updateUserStatus(isAnonymous)
                if (this.getSelectedEvent) {
                    if (this.getSelectedEvent[0].type === '1') { // Live Event
                        if (isAnonymous === '1') {
                            setTimeout(() => {
                                this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                                    if (this.getUserEvents) {
                                        let uEvent = this.getUserEvents.filter(ev => {
                                            return ev.eventId === this.getSelectedEvent[0].eventId
                                        })
                                        uEvent[0].isAnonymous = '1'
                                        uEvent[0].firstName = 'Shoe-cognito'
                                        this.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(() => {
                                            if (this.getUserSignature) {
                                                this.$router.push(`/liveevent/` + this.getSelectedEvent[0].eventId)
                                            }
                                        })
                                    }
                                })
                            }, 500)
                        } else {
                            this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(() => {
                                if (this.getUserSignature) {
                                    this.$router.push(`/liveevent/` + this.getSelectedEvent[0].eventId)
                                }
                            })
                        }
                    } else {
                        if (isAnonymous === '1') { // Talk Event
                            setTimeout(() => {
                                this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                                    if (this.getUserEvents) {
                                        let uEvent = this.getUserEvents.filter(ev => {
                                            return ev.eventId === this.getSelectedEvent[0].eventId
                                        })
                                        uEvent[0].isAnonymous = '1'
                                        uEvent[0].firstName = 'Shoe-cognito'
                                        this.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(() => {
                                            if (this.getUserSignature) {
                                                this.$router.push(`/talk/` + this.getSelectedEvent[0].eventId)
                                            }
                                        })
                                    }
                                })
                            }, 500)
                        } else {
                            this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(() => {
                                if (this.getUserSignature) {
                                    this.$router.push(`/talk/` + this.getSelectedEvent[0].eventId)
                                }
                            })
                        }
                    }
                }
            },
            getHoursFormatted (time) {
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'pm' : 'am'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = hours + ':' + minutes + ' ' + ampm
                return strTime
            },
            getDateReference (dte, type) {
                let dt = new Date(dte)
                let dayStr, monStr
                let eDay = dt.getDate()
                let eHours = this.getHoursFormatted(dt)
                let eMonth = dt.getMonth() + 1
                let day
                // Set Day of Date
                if (dt.getDay() === 0) {
                    day = 'Sunday'
                } else if (dt.getDay() === 1) {
                    day = 'Monday'
                } else if (dt.getDay() === 2) {
                    day = 'Tuesday'
                } else if (dt.getDay() === 3) {
                    day = 'Wednesday'
                } else if (dt.getDay() === 4) {
                    day = 'Thursday'
                } else if (dt.getDay() === 5) {
                    day = 'Friday'
                } else if (dt.getDay() === 6) {
                    day = 'Saturday'
                } else {
                    day = ''
                }
                // Set Date Pattern
                if (eDay === 1) {
                    dayStr = '1st'
                } else if (eDay === 2) {
                    dayStr = '2nd'
                } else if (eDay === 3) {
                    dayStr = '3rd'
                } else if (eDay === 21) {
                    dayStr = '21st'
                } else if (eDay === 22) {
                    dayStr = '22nd'
                } else if (eDay === 23) {
                    dayStr = '23rd'
                } else if (eDay === 31) {
                    dayStr = '31st'
                } else {
                    dayStr = eDay + 'th'
                }
                // Set Month
                if (eMonth === 1) {
                    monStr = 'January'
                } else if (eMonth === 2) {
                    monStr = 'February'
                } else if (eMonth === 3) {
                    monStr = 'March'
                } else if (eMonth === 4) {
                    monStr = 'April'
                } else if (eMonth === 5) {
                    monStr = 'May'
                } else if (eMonth === 6) {
                    monStr = 'June'
                } else if (eMonth === 7) {
                    monStr = 'July'
                } else if (eMonth === 8) {
                    monStr = 'August'
                } else if (eMonth === 9) {
                    monStr = 'September'
                } else if (eMonth === 10) {
                    monStr = 'October'
                } else if (eMonth === 11) {
                    monStr = 'November'
                } else if (eMonth === 12) {
                    monStr = 'December'
                }
                if (type === 'btn') {
                    return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!'
                } else if (type === 'live') {
                    return monStr + ' ' + eDay
                } else if (type === 'live2') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else if (type === 'str') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else {
                    return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET'
                }
            },
            setCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-eventusers')
                $slick.each(function () {
                    $slick.slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: false
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            },
            leaveEvent () {
                this.userAuthenticated = false
                window.scrollTo(0, 0)
            },
            refreshAttendees () {
                if (this.getSelectedEvent) {
                    this.$store.dispatch('GETEVENTUSERS', this.getSelectedEvent[0].eventId).then(() => {
                        if (this.getEventUsers) {
                            if (!this.getSelectedEvent[0].jw_rtmp_url) {
                                console.log('refreshing regular chat')
                                this.participantCount = this.getEventUsers.length
                                this.eventUsersArray.splice(0, this.eventUsersArray.length)
                                $(this.$el).find('.responsive-slick-eventusers').slick('unslick')
                                // Divide Users into sub array
                                this.eventUserArray = this.getEventUsers
                                while (this.eventUserArray.length > 0) {
                                    this.eventUsersArray.push(this.eventUserArray.splice(0, 9))
                                }
                                setTimeout(() => {
                                    this.setCarousal()
                                }, 1000)
                            } else {
                                console.log('refreshing Live chat', this.getEventUsers.length)
                                this.participantCount = this.getEventUsers.length
                            }
                        }
                    })
                }
            }
        },
        mounted () {
            let self = this
            self.$store.dispatch('GETDEMOEVENTS').then(() => {
                if (self.getDemoEvent) {
                    console.log('demo event details', self.getDemoEvent)
                    self.chatrllRef = self.getDemoEvent.chatrollEventUrl
                    self.$store.dispatch('GETEXPERT', self.getDemoEvent.expertId).then(() => {
                    })
                    if (self.getDemoEvent.videoCode && self.getDemoEvent.videoCode.length > 2) {
                        self.$store.dispatch('GETCURRENTVIDEO', self.getDemoEvent.videoCode).then(() => {
                            console.log('current video', self.getCurrentVideo)
                            if (self.getCurrentVideo) {
                                let videoObj = self.getCurrentVideo[0]
                                self.currentVideo = {
                                    video: videoObj.sources[videoObj.sources.length - 1].file,
                                    title: videoObj.title,
                                    img: videoObj.image,
                                    playerID: new Date(),
                                    tracks: videoObj.tracks,
                                    Description: videoObj.description,
                                    mediaId: videoObj.mediaid,
                                    isMute: true
                                }
                            }
                        })
                    }
                }
            })
            setTimeout(function () {
                window.addeventatc.refresh()
            }, 2000)
//            if (this.getDemoEvent) {
//                if (this.userType === 0) {
//                    this.chatRollURL = `${this.getDemoEvent.chatrollEventUrl}&uid=1169&uname=admin&sig=382cc56548973850830a3eb291a5fdf6&ismod=0&upic=https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg`
//                } else {
//                    this.chatRollURL = `${this.getDemoEvent.chatrollEventUrl}&uid=1169&uname=Shoe-cognito&sig=382cc56548973850830a3eb291a5fdf6&ismod=0&upic=https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg`
//                }
//                this.jwEventRef = this.getDemoEvent.jwRtmpUrl
//            }
//            this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {})
        },
        beforeDestroy () {
//            this.leaveEvent()
//            clearInterval(window['interval'])
        },
        computed: {
            ...mapGetters([
                'user', 'getExpert', 'getSelectedEvent', 'getUserEvents', 'getEventUsers', 'getUserSignature', 'getUserStatus', 'getDemoEvent', 'getCurrentVideo']
            )
        }
    }
</script>

<style scoped>
    .attendeesImg>.userImage span {
        word-wrap: normal;
        white-space: nowrap;
    }
    .btn-pink{
        color: #f0617d;
        border: 1px solid #f0617d;
        background: none;
        outline: none;
        font-size: 16px;
        font-family: sans-serif;
        letter-spacing: 0.3px;
        float: left;
        margin-left: 0px;
        width: 100%;
        padding: 13px 15px 9px;
        border-radius: 3px;
        margin-top: 10px;
        max-width: 100%;
    }
    @media(min-width:768px){
        .innerpadding {
            padding-top: 36px;
        }
    }
</style>



// WEBPACK FOOTER //
// DemoEvent.vue?21f75dd3